import firebase from 'firebase/app';
import 'firebase/firestore';

const firestore = () => firebase.firestore();

firestore.doc = (path) => firebase.firestore().doc(path);

firestore.collection = (path) => firebase.firestore().collection(path);

firestore.getDocument = (doc) => doc.get();

firestore.setDocument = async (doc, data, options) => doc.set(data, options);

firestore.updateDocument = async (doc, data) => doc.update(data);

firestore.runTransaction = (updateFunction) => firebase.firestore().runTransaction(updateFunction);

firestore.FieldValue = firebase.firestore.FieldValue;

export default firestore;
